<!-- Header -->
<div>
    <div class="card-header mb-4">
        <div class="title-section">
            <h2 class="header-title">Consulta de Log</h2>
        </div>
    </div>
    <!-- Tabla Principal -->
    <div>
        <p-table
            #dt
            [value]="reportes"
            [columns]="columns"
            [paginator]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[5,10,20]"
            [scrollable]="true"
            scrollHeight="400px"
            styleClass="p-datatable-gridlines"
            [resizableColumns]="true"
            [autoLayout]="true"
            responsiveLayout="scroll"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        >
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="th-prime">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                    <th class="th-prime">Acciones</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" class="td-prime">
                        {{rowData[col.field]}}
                    </td>
                    <td class="td-prime text-center">
                        <button mat-flat-button (click)="getConfReport(rowData)" 
                                class="btn-new" 
                                [disabled]="disabled">
                            <mat-icon>edit</mat-icon>
                            Generar Reporte
                        </button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="columns.length + 1" class="text-center td-prime">
                        No hay datos para mostrar
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div> 